import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { TextLabelMdeEditorComponent } from '../../pages/form-builder/fields/text-label/text-label-mde-editor.component';

/**
 * Formly wrapper for TextLabelMdeEditorComponent.
 *
 * Allows the EasyMDE markdown editor to be used as a Formly field type in
 * the text-label field config editor form.
 *
 * Bridges Formly's formControl binding to the component's signal-based API:
 * - formControl.value → [value] input signal
 * - (valueChange) output → formControl.setValue() + markAsDirty()
 *
 * Usage in FormlyFieldConfig:
 * ```typescript
 * {
 *   key: 'content',
 *   type: 'mde-editor',
 *   className: 'flex-basis-full',
 *   props: {
 *     label: 'formBuilder.content',
 *     placeholder: 'formBuilder.contentPlaceholder',
 *   },
 * }
 * ```
 */
@Component({
  selector: 'app-mde-editor-formly-type',
  standalone: true,
  imports: [TextLabelMdeEditorComponent],
  template: `
    <app-text-label-mde-editor
      [value]="formControl.value || ''"
      [placeholder]="props['placeholder'] || ''"
      (valueChange)="onValueChange($event)"
    />
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: `
    :host {
      flex-basis: 100%;
      display: block;
    }
  `,
})
export class MdeEditorFormlyTypeComponent extends FieldType<FieldTypeConfig> {
  onValueChange(newValue: string): void {
    this.formControl.setValue(newValue);
    this.formControl.markAsDirty();
  }
}
